import { useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { matchesActivationRoute } from "../activation/activationPath";

import { useTrainingMode } from "./TrainingModeContext";



/** Navigate to lesson route only after menu substeps, when not already there. */

export default function TrainingAutoNav() {

  const navigate = useNavigate();

  const location = useLocation();

  const { active, pendingLessonRoute, clearPendingLessonRoute } =

    useTrainingMode();



  useEffect(() => {

    if (!active || !pendingLessonRoute) return undefined;

    if (

      matchesActivationRoute(

        location.pathname,

        location.search,

        pendingLessonRoute,

      )

    ) {

      clearPendingLessonRoute();

      return undefined;

    }

    navigate(pendingLessonRoute);

    clearPendingLessonRoute();

    return undefined;

  }, [

    active,

    pendingLessonRoute,

    navigate,

    clearPendingLessonRoute,

    location.pathname,

    location.search,

  ]);



  return null;

}


